import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiGet, apiPost } from 'services/api';
import { ICreateManualQuotation, ILogisticServiceType, ILogisticServiceWithProductPrices } from 'types/services';

const { REACT_APP_SUBSCRIPTION } = process.env;

const getLogisticServiceWithProductPrices = async (logisticServiceId: string | number) => {
  return apiGet<AxiosRequestConfig, ILogisticServiceWithProductPrices>(
    `${REACT_APP_SUBSCRIPTION}/logistic-service/with-product-prices/${logisticServiceId}`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const createManualQuotation = async (body: ICreateManualQuotation) => {
  return apiPost<AxiosRequestConfig, ICreateManualQuotation>(
    `${REACT_APP_SUBSCRIPTION}/logistic-service-edit-price/bulk-changes-with-items`,
    body
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const getLogisticServiceTypes = async (): Promise<ILogisticServiceType[]> => {
  return apiGet<AxiosRequestConfig, ILogisticServiceType[]>(`${REACT_APP_SUBSCRIPTION}/logistic-service-type`)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export { getLogisticServiceWithProductPrices, createManualQuotation, getLogisticServiceTypes };
